export const facebookRegex = new RegExp(
  /(?:https?:\/\/)?(?:www\.)?facebook\.com\/(?:(?:\w\.)*#!\/)?(?:pages\/)?(?:[\w\-.]*\/)*([\w\-.]*)/
);

export const atUsernameRegex = new RegExp(
  /(?:^|[^\w])(?:@)([A-Za-z0-9_](?:(?:[A-Za-z0-9_]|(?:\.(?!\.))){0,28}(?:[A-Za-z0-9_]))?)/
);

export const hasImageUrl = (value: any): boolean => {
  return (
    value != null &&
    value !== undefined &&
    value !== "" &&
    typeof value == "string"
  );
};

export const isDefined = (value: any): boolean => {
  return value != null && value !== undefined;
};

export const parseGraphQLError = (error: any): string => {
  if (error?.graphQLErrors?.length > 0) {
    const graphQLError = error.graphQLErrors[0];
    const message = graphQLError.message;

    if (message.includes("Unique constraint failed on the fields: (`email`)")) {
      return "This email address is already registered. Please use a different email.";
    }

    if (message.includes("Unique constraint failed")) {
      return "This information already exists. Please check your input.";
    }

    if (message.includes("Invalid") || message.includes("validation")) {
      return "Please check your input and try again.";
    }

    return graphQLError.message;
  }

  if (error?.networkError) {
    return "Network error. Please check your internet connection and try again.";
  }

  if (error?.message) {
    return error.message;
  }

  return "An unexpected error occurred. Please try again.";
};
